import { render, staticRenderFns } from "./ReviewUndefined.vue?vue&type=template&id=4c2e447f&"
import script from "./ReviewUndefined.vue?vue&type=script&lang=js&"
export * from "./ReviewUndefined.vue?vue&type=script&lang=js&"
import style0 from "../css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports